import { SuitOrder } from '../../app/types';
import { renderSuits } from '../../utils/mixed';
import React, { FunctionComponent } from 'react';

import './loading-component.scss';

export const LoadingComponent: FunctionComponent = () => {
    return <section className="LoadingComponent">{renderSuits(SuitOrder.SHDC)}</section>;
};
